import { Box } from '@mui/material';

/**
 * Crisp, vector language flags. Replaces emoji flags (🇬🇧/🇫🇷) which render as
 * blurry, OS-dependent bitmaps. SVG stays sharp at any zoom / DPI.
 *
 * We intentionally show the flag AND the language code so the switcher reads
 * clearly even where flag↔language mapping is ambiguous (a flag is a country,
 * not a language). The founder is trialling both treatments together.
 */

function GBFlag({ size = 18 }: { size?: number }) {
  // Simplified Union Jack — recognisable, geometry-only, no raster.
  return (
    <svg width={size} height={size * 0.7} viewBox="0 0 60 42" aria-hidden focusable="false"
      style={{ display: 'block', borderRadius: 2 }}>
      <rect width="60" height="42" fill="#012169" />
      <path d="M0,0 L60,42 M60,0 L0,42" stroke="#fff" strokeWidth="8" />
      <path d="M0,0 L60,42 M60,0 L0,42" stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 V42 M0,21 H60" stroke="#fff" strokeWidth="12" />
      <path d="M30,0 V42 M0,21 H60" stroke="#C8102E" strokeWidth="7" />
    </svg>
  );
}

function FRFlag({ size = 18 }: { size?: number }) {
  return (
    <svg width={size} height={size * 0.7} viewBox="0 0 60 42" aria-hidden focusable="false"
      style={{ display: 'block', borderRadius: 2 }}>
      <rect width="20" height="42" fill="#0055A4" />
      <rect x="20" width="20" height="42" fill="#fff" />
      <rect x="40" width="20" height="42" fill="#EF4135" />
    </svg>
  );
}

export function LanguageFlag({ code, size = 18 }: { code: string; size?: number }) {
  if (code === 'fr') return <FRFlag size={size} />;
  return <GBFlag size={size} />;
}

/** Flag + uppercase language code, both crisp. */
export function LanguageBadge({ code }: { code: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, lineHeight: 1 }}>
      <LanguageFlag code={code} size={18} />
      <Box component="span" sx={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.3 }}>
        {code.toUpperCase()}
      </Box>
    </Box>
  );
}
